/* eslint-disable sonarjs/cognitive-complexity */
import React from 'react';
import Carousel from '@tcp/core/src/components/common/molecules/Carousel/container/index.async';
import PropTypes from 'prop-types';
import ClickTracker from '@tcp/web/src/components/common/atoms/ClickTracker';
import RecommendationTile from '@tcp/core/src/components/common/molecules/RecommendationCarousel/views/RecommendationTile.view';
import withStyles from '../../../../common/hoc/withStyles';
import BIAProductTileView from './BIAProductTile.view';
import Anchor from '../../../../common/atoms/Anchor';
import Row from '../../../../common/atoms/Row';
import { getIconPath, getViewportInfo, isClient } from '../../../../../utils';
import config from '../views/config';
import { processProductData } from '../../../../../services/abstractors/SFCC/BuyItAgain';
import { RecommendationCol } from '../../../../common/molecules/Recommendations/styles/Recommendations.style';
import styles from '../styles/BIAStackedCarousel.style';
import BUY_IT_AGAIN_BAG_PAGE_CONSTANTS from '../container/BuyItAgainBagPage.constants';
import BagpageUtils from '../../BagPage/views/Bagpage.utils';
import {
  getLabelFromCopyOrFromTranslation,
  renderLabel,
} from '../../../../../utils/labels/labelUtilty';
import BuyItAgainBagPageLabels, { GLOBAL_LABELS } from '../views/BuyItAgainBagPage.labels';

const BIACarousel = (props) => {
  const globalLabels = getLabelFromCopyOrFromTranslation(GLOBAL_LABELS, BuyItAgainBagPageLabels);
  const {
    className,
    fromStackedCarousel,
    openShopAllDrawer,
    biaProducts,
    getBIADrawerproducts,
    isNoNEmptyBag,
    isRecommendationCarouselRedesignEnabled,
    orderItemsCount,
    spcBag,
    currencySymbol,
  } = props;
  const processData = processProductData(biaProducts);
  const carouselOptionsFinal = isRecommendationCarouselRedesignEnabled
    ? { ...config.CAROUSEL_OPTIONS_REDESIGN }
    : { ...config.CAROUSEL_OPTIONS };
  if (getViewportInfo()?.isLargeDesktop) {
    carouselOptionsFinal.slidesToShow = 6;
    carouselOptionsFinal.slidesToScroll = 6;
  }
  let carouselOptions;

  if (isNoNEmptyBag) {
    if (isRecommendationCarouselRedesignEnabled) {
      carouselOptions = BagpageUtils.CarouselOptions.CAROUSEL_OPTIONS_REDESIGN;
    } else carouselOptions = BagpageUtils.CarouselOptions.CAROUSEL_OPTIONS;
  }

  if (processData?.length < 6) {
    carouselOptionsFinal.infinite = false;
    if (isNoNEmptyBag) {
      carouselOptions.infinite = false;
    }
  }
  if (processData?.length === 5) {
    carouselOptionsFinal.infinite = false;

    carouselOptionsFinal.slidesToShow = 4;
    carouselOptionsFinal.slidesToScroll = 4;
  }
  const carouselProps = {
    ...carouselOptionsFinal,
    ...carouselOptions,
    adaptiveHeight: false,
  };
  const openShopAllBIADrawer = () => {
    getBIADrawerproducts();
    openShopAllDrawer(true);
  };

  const shouldShowShopAllLink = () => {
    let isShouldShowShopAllLink = true;
    const { biaInitialApiActualProductCount, getBIAConfigData } = props;
    const biaCarouselStaticProductCount = getBIAConfigData?.noOfProducts;
    const biaBagPageCarousalProductLength = biaProducts?.length;
    const biaInitialApiProductCountStatic =
      BUY_IT_AGAIN_BAG_PAGE_CONSTANTS?.BUY_IT_AGAIN_INITIAL_API_PRODUCT_COUNT_STATIC;
    if (
      biaInitialApiActualProductCount < biaInitialApiProductCountStatic &&
      biaBagPageCarousalProductLength < biaCarouselStaticProductCount
    ) {
      isShouldShowShopAllLink = false;
    } else if (
      biaInitialApiActualProductCount < biaInitialApiProductCountStatic &&
      biaBagPageCarousalProductLength > biaCarouselStaticProductCount
    ) {
      isShouldShowShopAllLink = true;
    } else if (biaInitialApiActualProductCount >= biaInitialApiProductCountStatic) {
      isShouldShowShopAllLink = true;
    }
    return isShouldShowShopAllLink;
  };
  const isShopAllLinkVisible = shouldShowShopAllLink();
  const isMobile = isClient() ? getViewportInfo().isMobile : null;
  return (
    <div className={className}>
      <Row fullBleed className={`recommendations-section-row`}>
        <RecommendationCol
          showPeek={true}
          newRecommendationEnabled={true}
          className="recommendations-section-col"
          colSize={{
            small: 6,
            medium: 8,
            large: 10,
          }}
          offsetLeft={{
            small: 0,
            medium: 0,
            large: 1,
          }}
        >
          {isMobile ? (
            <div className="smooth-scroll-list scroll-container-mobile-tablet">
              {processData.map((product) => {
                const productId = product?.productInfo?.generalProductId || product.uniqueId;
                return (
                  <div className="smooth-scroll-list-item">
                    {isRecommendationCarouselRedesignEnabled ? (
                      <RecommendationTile
                        key={productId}
                        product={product}
                        orderItemsCount={orderItemsCount}
                        spcBag={spcBag}
                        currencySymbol={currencySymbol}
                        {...props}
                      />
                    ) : (
                      <BIAProductTileView product={product} {...props} />
                    )}
                  </div>
                );
              })}
            </div>
          ) : (
            <Carousel
              className={`${'variation'}-variation`}
              options={carouselProps}
              inheritedStyles={Carousel}
              carouselConfig={
                isRecommendationCarouselRedesignEnabled
                  ? {
                      customArrowLeft: getIconPath('icon-carrot-grey-large'),
                      customArrowRight: getIconPath('icon-carrot-grey-large'),
                      dataLocatorCarousel: `${'variation'}-variation`,
                    }
                  : {
                      variation: 'big-arrows',
                      customArrowLeft: getIconPath('carousel-big-carrot'),
                      customArrowRight: getIconPath('carousel-big-carrot'),
                      dataLocatorCarousel: `${'variation'}-variation`,
                    }
              }
              isPDP={false}
            >
              {processData.map((product, index) => {
                const productId = product?.productInfo?.generalProductId || product.uniqueId;
                return (
                  <>
                    {isRecommendationCarouselRedesignEnabled ? (
                      <RecommendationTile
                        key={productId}
                        product={product}
                        index={index}
                        orderItemsCount={orderItemsCount}
                        spcBag={spcBag}
                        {...props}
                      />
                    ) : (
                      <BIAProductTileView
                        product={product}
                        amountOfBIAProducts={processData?.length}
                        index={index}
                        {...props}
                      />
                    )}
                  </>
                );
              })}
            </Carousel>
          )}
        </RecommendationCol>
        <div className="shop-all-cont">
          {!fromStackedCarousel && isShopAllLinkVisible && (
            <ClickTracker
              clickData={{
                metric81: '1',
                eVar19: 'bag_na_na_na_na_buyitagainviewall',
                customEvents: ['event81', 'eVar19'],
              }}
            >
              <Anchor
                handleLinkClick={(e) => {
                  e.preventDefault();
                  openShopAllBIADrawer();
                }}
                className="bia-shop-all"
                noLink
              >
                {renderLabel(
                  globalLabels?.CommonBrowseLabels?.lbl_plp_shop_all,
                  'lbl_plp_shop_all'
                )}
              </Anchor>
            </ClickTracker>
          )}
        </div>
      </Row>
    </div>
  );
};
BIACarousel.propTypes = {
  biaProducts: PropTypes.shape([]),
  onQuickViewOpenClick: PropTypes.func,
  className: PropTypes.string,
  fromStackedCarousel: PropTypes.bool,
  openShopAllDrawer: PropTypes.func,
  getBIADrawerproducts: PropTypes.func,
};

BIACarousel.defaultProps = {
  onQuickViewOpenClick: () => {},
  className: 'class',
  biaProducts: [],
  fromStackedCarousel: false,
  openShopAllDrawer: () => {},
  getBIADrawerproducts: () => {},
};
export default withStyles(BIACarousel, styles);
export { BIACarousel as BIACarouselVanilla };
